document.addEventListener('click', function (event) {
  const openButton = event.target.closest('[data-maker-modal-open]');

  if (openButton) {
    const modalId = openButton.dataset.makerModalOpen;
    const modal = document.getElementById(modalId);

    if (modal && typeof modal.showModal === 'function') {
      modal.showModal();
    }

    return;
  }

  const closeButton = event.target.closest('.maker-modal__close');

  if (closeButton) {
    const modal = closeButton.closest('dialog');

    if (modal) {
      modal.close();
    }

    return;
  }

  if (
    event.target.tagName === 'DIALOG' &&
    event.target.classList.contains('maker-modal')
  ) {
    event.target.close();
  }
});